import { createSlice } from "@reduxjs/toolkit";

const toSerializable = (value) => {
  if (value === null || value === undefined) return value;

  if (Array.isArray(value)) {
    return value.map((item) => toSerializable(item));
  }

  if (typeof value === "object") {
    // Firestore Timestamp-like objects expose toDate()
    if (typeof value.toDate === "function") {
      return value.toDate().toISOString();
    }

    const output = {};
    Object.keys(value).forEach((key) => {
      output[key] = toSerializable(value[key]);
    });
    return output;
  }

  return value;
};

const initialWasherState = {
  user: null,
  washer: null,
  isEmailVerified: false,
  onboardingStep: "email_verification",
  request: null,
  contract: null,
};

const washerSlice = createSlice({
  name: "washer",
  initialState: initialWasherState,
  reducers: {
    setWasher(state, action) {
      state.washer = toSerializable(action.payload);
    },
    setUser(state, action) {
      state.user = toSerializable(action.payload);
    },
    setIsEmailVerified(state, action) {
      state.isEmailVerified = action.payload;
    },
    setOnboardingStep(state, action) {
      state.onboardingStep = action.payload;
    },
    setRequest(state, action) {
      state.request = toSerializable(action.payload);
    },
    setContract(state, action) {
      state.contract = toSerializable(action.payload);
    },
    resetSession: () => ({ ...initialWasherState }),
  },
});

export const washerActions = washerSlice.actions;
export default washerSlice.reducer;
